import React, { useEffect } from "react";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces/identityVerificationRequest";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { useIdentityVerificationRequestQuery } from "../../../../../query/identityVerification/query/useIdentityVerificationRequestQuery";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";
import { RequirementCardContent } from "../../../components/RequirementCardContent";
import { RequirementEvent } from "../../../utils";
import {
  IDENTITY_VERIFICATION_REQUIREMENT_EVENT,
  useIDVPendingSuccessStatus
} from "../configs/utils";

export const ValidationProgress: React.FC<{
  identityVerificationRequest: IIdentityVerificationRequestResponse | undefined;
  requirement: IRequirementResponse;
  onSuccess: (
    event: RequirementEvent,
    requirement: IRequirementResponse
  ) => void;
}> = ({ requirement, identityVerificationRequest, onSuccess }) => {
  const queryIdentityVerificationRequest = useIdentityVerificationRequestQuery(
    identityVerificationRequest?.identityVerificationRequestId!,
    {
      enabled: !!identityVerificationRequest?.identityVerificationRequestId
    }
  );

  const { setPendingSuccessStatus } = useIDVPendingSuccessStatus();

  useEffect(() => {
    // Refetch the shared file request if the status is Processing
    if (
      queryIdentityVerificationRequest.data?.status ===
      IdentityVerificationRequestStatus.Pending
    ) {
      // Refetch the shared file request for every 5 seconds
      const interval = setInterval(() => {
        // This is to ensure that the status is updated real-time in the UI
        queryIdentityVerificationRequest.refetch().then(result => {
          if (
            result.data?.status ===
              IdentityVerificationRequestStatus.Complete ||
            result.data?.status === IdentityVerificationRequestStatus.Failed
          ) {
            clearInterval(interval);
            setPendingSuccessStatus(
              requirement,
              queryIdentityVerificationRequest.data
            );
            onSuccess(
              IDENTITY_VERIFICATION_REQUIREMENT_EVENT.CompleteVerification,
              requirement
            );
          }
        });
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [queryIdentityVerificationRequest.data?.status]);

  return (
    <RequirementCardContent
      type="people"
      title="Your ID verification is being processed"
      description="This typically takes up to 5 minutes. Your payer will be notified when it is complete."
    />
  );
};
